import { takeEvery, put, call, select } from 'redux-saga/effects';
import {
  REQUESTED_SAVE_RESCUE_DETAILS_RETRIEVE_RESULTS,
  saveRescueDetailsRetrieveResultsSuccess,
  saveRescueDetailsRetrieveResultsFailed,
  updateVehicle,
  updatePromoCode,
  updateMemberId,
  updatePartnerMemberId,
} from '../action';
import { saveRescueDetails } from '../api';
import { datadogRum } from "@datadog/browser-rum";
import {
  getCommonBenefits,
  getPartnerDetails,
  getServiceCoverageDetails,
  getServiceInfo,
  getServiceRequest,
  getServiceRequestPayload,
  getTireChangeServiceDetails,
} from "../selector";
import {handleBenefitIds, handlePromoCode} from "./helpers";


function mapPinVehicleToTargetFormat(pinVehicle) {
  return {

    vehicleID: pinVehicle.id || "",
    equipmentClass: pinVehicle.serviceWeight || "",
    make: pinVehicle.make?.toUpperCase() || "",
    model: pinVehicle.model?.toUpperCase() || "",
    year: pinVehicle.year?.toString() || "",
    color: pinVehicle.color?.toUpperCase() || "",
    vin: pinVehicle.vin || "",
    coveredVehicle: pinVehicle?.coveredVehicle || false
  };
}

export function* saveRescueDetailsSaga(action) {
  try {
    const { serviceType, history , dispatcher, addNewVehicle, navigateOnSuccess } = action.payload;

    // Get data from Redux state
    const commonBenefits = yield select(getCommonBenefits);
    const partnerDetails = yield select(getPartnerDetails);
    const serviceInfo = yield select(getServiceInfo);
    const serviceRequest = yield select(getServiceRequest);
    const tireChangeServiceDetails = yield select(getTireChangeServiceDetails);
    const serviceRequestPayload = yield select(getServiceRequestPayload);
    const promoCode = handlePromoCode({
      commonBenefits,
      partnerDetails,
      serviceRequest,
      tireChangeServiceDetails,
      serviceRequestPayload
    });
    if (promoCode !== undefined) {
      yield put(updatePromoCode(promoCode));
    }

    const { memberId, partnerMemberId } = handleBenefitIds({ commonBenefits, serviceRequest, tireChangeServiceDetails });
    if (memberId !== undefined) {
      yield put(updateMemberId(memberId));
    }
    if (partnerMemberId !== undefined) {
      yield put(updatePartnerMemberId(partnerMemberId));
    }



    const response = yield call(
      saveRescueDetails,
      serviceRequestPayload,
      partnerDetails.partnerCode,
      serviceType || serviceInfo.service,
      history,
      dispatcher
    );

    if (response && response.status >= 200 && response.status < 300) {
      // Dispatch success action
      yield put(saveRescueDetailsRetrieveResultsSuccess(response.data));
      if(addNewVehicle){
        const newVehicle = mapPinVehicleToTargetFormat(response?.data?.body);
        yield put(updateVehicle(newVehicle));
      }

      datadogRum.addAction("Save Rescue Details - Success");
      if(navigateOnSuccess){
        navigateOnSuccess();
      }
    } else {
      // Handle API error response
      yield put(saveRescueDetailsRetrieveResultsFailed(response));
      datadogRum.addError("Save Rescue Details - API Error", response);
    }
  } catch (error) {
    // Handle saga error
    yield put(saveRescueDetailsRetrieveResultsFailed(error));
    datadogRum.addError("Save Rescue Details - Saga Error", error);
  }
}

export function* watchSaveRescueDetailsRetrieveResults() {
  yield takeEvery(REQUESTED_SAVE_RESCUE_DETAILS_RETRIEVE_RESULTS, saveRescueDetailsSaga);
}
